(() => {
  'use strict';
  if (customElements.get('fs-live-quickview')) return;

  const safeImage = (value, base) => {
    try {
      const url = new URL(value || '', base);
      return value && url.protocol === 'https:' ? url.href : '';
    } catch (_) { return ''; }
  };
  const allowedTags = new Set(['P', 'DIV', 'SECTION', 'SPAN', 'STRONG', 'B', 'EM', 'I', 'U', 'S', 'BR', 'HR', 'UL', 'OL', 'LI', 'DL', 'DT', 'DD', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'TABLE', 'THEAD', 'TBODY', 'TFOOT', 'TR', 'TH', 'TD', 'CAPTION', 'FIGURE', 'FIGCAPTION', 'IMG', 'BLOCKQUOTE', 'SUP', 'SUB']);
  const blockedTags = new Set(['SCRIPT', 'STYLE', 'IFRAME', 'OBJECT', 'EMBED', 'FORM', 'INPUT', 'SELECT', 'TEXTAREA', 'BUTTON', 'TEMPLATE', 'NOSCRIPT', 'SVG', 'MATH', 'LINK', 'META']);

  class FsLiveQuickview extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.owner = this.closest('[data-fs-live-collection]');
      this.dialog = this.querySelector('dialog');
      if (!this.owner || !this.dialog) return;
      this.connected = true;
      this.closeButton = this.el('close');
      this.image = this.el('image');
      this.photos = [];
      this.carousel = this.querySelector('.fs-live-quickview__photo');
      this.carousel.setAttribute('data-fs-product-carousel', '');
      this.noImageText = this.el('no-image').textContent;
      this.onPhotoScroll = () => {
        const width = this.carousel.clientWidth;
        if (!width || !this.photos.length) return;
        const index = Math.max(0, Math.min(this.photos.length - 1, Math.round(this.carousel.scrollLeft / width)));
        this.selectPhoto(index);
      };
      this.onOwnerClick = (event) => {
        const opener = event.target.closest('[data-fs-live-quickview]');
        if (!opener || !this.owner.contains(opener)) return;
        event.preventDefault();
        this.open(opener);
      };
      this.onClick = (event) => {
        const close = event.target.closest('[data-fs-product-close], [data-fs-product-back]');
        if (close) this.close();
        const photo = event.target.closest('[data-fs-product-photo]');
        if (photo) this.showPhoto(Number(photo.dataset.fsProductPhoto));
        if (event.target.closest('[data-fs-product-prev]')) this.showPhoto(this.photoIndex - 1);
        if (event.target.closest('[data-fs-product-next]')) this.showPhoto(this.photoIndex + 1);
        if (event.target.closest('[data-fs-product-retry]')) this.open(this.opener);
        if (event.target === this.dialog && this.backdropStart) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
        }
        this.backdropStart = false;
      };
      this.onPointerDown = (event) => { this.backdropStart = event.target === this.dialog; };
      this.onCancel = (event) => { event.preventDefault(); this.close(); };
      this.onClose = () => {
        this.controller?.abort();
        this.unlockScroll();
        const opener = this.opener?.isConnected ? this.opener : this.owner.querySelector('[data-fs-live-quickview="' + this.productId + '"]');
        (opener || this.owner.querySelector('fs-live-size-filter button, a[href]'))?.focus({ preventScroll: true });
      };
      this.onKeyDown = (event) => {
        if (event.key !== 'Tab') return;
        const focusable = Array.from(this.dialog.querySelectorAll('button:not([disabled]), [href], summary, [tabindex]:not([tabindex="-1"])')).filter((node) => !node.closest('[hidden]') && node.getClientRects().length);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        const current = this.ownerDocument.activeElement;
        if (!first) { event.preventDefault(); this.closeButton.focus(); return; }
        if (event.shiftKey && (current === first || !this.dialog.contains(current))) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && (current === last || !this.dialog.contains(current))) { event.preventDefault(); first.focus(); }
      };
      this.onHistory = () => this.close();
      window.addEventListener('popstate', this.onHistory);
      this.owner.addEventListener('click', this.onOwnerClick);
      this.owner.setAttribute('data-fs-live-quickview-ready', '');
      this.carousel.addEventListener('scroll', this.onPhotoScroll, { passive: true });
      if (typeof ResizeObserver === 'function') {
        this.carouselWidth = 0;
        this.carouselObserver = new ResizeObserver(() => {
          const width = this.carousel.clientWidth;
          if (width > 0 && width !== this.carouselWidth) {
            this.carouselWidth = width;
            this.alignPhoto();
          }
        });
        this.carouselObserver.observe(this.carousel);
      }
      this.dialog.addEventListener('click', this.onClick);
      this.dialog.addEventListener('pointerdown', this.onPointerDown);
      this.dialog.addEventListener('cancel', this.onCancel);
      this.dialog.addEventListener('close', this.onClose);
      this.dialog.addEventListener('keydown', this.onKeyDown);

    }

    disconnectedCallback() {
      this.controller?.abort();
      this.unlockScroll();
      this.owner?.removeEventListener('click', this.onOwnerClick);
      this.owner?.removeAttribute('data-fs-live-quickview-ready');
      window.removeEventListener('popstate', this.onHistory);
      this.carousel?.removeEventListener('scroll', this.onPhotoScroll);
      this.carouselObserver?.disconnect();
      if (this.dialog) {
        this.dialog.removeEventListener('click', this.onClick);
        this.dialog.removeEventListener('pointerdown', this.onPointerDown);
        this.dialog.removeEventListener('cancel', this.onCancel);
        this.dialog.removeEventListener('close', this.onClose);
        this.dialog.removeEventListener('keydown', this.onKeyDown);
        if (this.dialog.open) this.dialog.close();
      }
      this.connected = false;
    }

    el(name) { return this.querySelector('[data-fs-product-' + name + ']'); }
    label(name) { return this.dataset[name] || ''; }
    money(value) {
      return new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: this.dataset.currency || 'PKR' }).format(value / 100);
    }
    close() { if (this.dialog.open) this.dialog.close(); }
    lockScroll() {
      if (this.scrollLock) return;
      const body = this.ownerDocument.body;
      const html = this.ownerDocument.documentElement;
      this.scrollLock = { body: body.style.overflow, html: html.style.overflow };
      body.style.overflow = 'hidden';
      html.style.overflow = 'hidden';
    }
    unlockScroll() {
      if (!this.scrollLock) return;
      this.ownerDocument.body.style.overflow = this.scrollLock.body;
      this.ownerDocument.documentElement.style.overflow = this.scrollLock.html;
      this.scrollLock = null;
    }
    productURL(product, opener) {
      const url = new URL(product.url || opener.dataset.productUrl || '', location.origin);
      if (url.origin !== location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) throw new Error('Invalid product URL');
      url.pathname = url.pathname.replace(/\/$/, '');
      url.searchParams.delete('preview_theme_id');
      url.hash = '';
      const preview = this.dataset.previewThemeId;
      if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id', preview);
      const variant = opener.dataset.variant;
      if (variant && /^\d+$/.test(variant)) url.searchParams.set('variant', variant);
      return url;
    }
    async request(url, signal, format) {
      const response = await fetch(url.href, { method: 'GET', credentials: 'same-origin', cache: 'no-store', signal, headers: { Accept: format === 'json' ? 'application/json' : 'text/html' } });
      if (!response.ok) throw new Error('Product details unavailable');
      return format === 'json' ? response.json() : response.text();
    }
    async open(opener) {
      if (!opener || typeof this.dialog.showModal !== 'function') return;
      const productId = String(opener.dataset.fsLiveQuickview || '');
      if (!/^\d+$/.test(productId)) return;
      const product = { id: productId, title: opener.dataset.productTitle || '', url: opener.dataset.productUrl || '', image: opener.dataset.productImage || '' };
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.opener = opener;
      this.productId = productId;
      this.el('title').textContent = product.title;
      this.el('price').textContent = '';
      this.el('status').textContent = this.label('labelLoading');
      this.el('retry').hidden = true;
      this.el('empty').hidden = true;
      this.el('description').hidden = true;
      this.el('description-content').replaceChildren();
      this.el('details').replaceChildren();
      this.el('link').removeAttribute('href');
      this.el('content').setAttribute('aria-busy', 'true');
      this.descriptionLoaded = false;
      this.detailsLoaded = false;
      this.setPhotos(product.image ? [{ src: product.image, alt: product.title }] : []);
      if (!this.dialog.open) {
        this.dialog.showModal();
        this.lockScroll();
      }
      this.alignPhoto();
      this.el('scroll').scrollTop = 0;
      this.closeButton.focus({ preventScroll: true });
      let timer;
      try {
        const url = this.productURL(product, opener);
        this.el('link').href = url.href;
        const jsonURL = new URL(url.href);
        jsonURL.pathname += '.js';
        const controller = this.controller;
        timer = setTimeout(() => controller.abort(), 15000);
        const current = () => !signal.aborted && this.dialog.open && this.controller === controller;
        const results = await Promise.allSettled([
          this.request(jsonURL, signal, 'json').then((data) => {
            if (!current()) return;
            if (!data || String(data.id) !== productId || !Array.isArray(data.images)) throw new Error('Mismatched product');
            this.el('title').textContent = String(data.title || product.title);
            const photoMeta = new Map((data.media || []).filter((media) => media.media_type === 'image' && media.preview_image?.src).map((media) => [safeImage(media.preview_image.src, url), media.alt]));
            this.setPhotos(data.images.map((image) => {
              const src = typeof image === 'string' ? image : image.src;
              return { src, alt: (typeof image === 'object' && image.alt) || photoMeta.get(safeImage(src, url)) || data.title || product.title };
            }));
            const variantId = opener.dataset.variant;
            const variant = (data.variants || []).find((item) => String(item.id) === String(variantId));
            const price = variant ? variant.price : data.price_min ?? data.price;
            if (Number.isSafeInteger(price) && price >= 0 && typeof this.money === 'function') {
              const max = !variant && Number.isSafeInteger(data.price_max) && data.price_max > price ? ' – ' + this.money(data.price_max) : '';
              this.el('price').textContent = this.money(price) + max;
            }
            if (data.description) this.setDescription(data.description, url);
          }),
          this.request(url, signal, 'html').then((html) => {
            if (!current()) return;
            const page = new DOMParser().parseFromString(html, 'text/html');
            const main = page.querySelector('product-info[id^="MainProduct-"]');
            if (!main || String(main.dataset.productId) !== productId) throw new Error('Mismatched product details');
            if (!this.descriptionLoaded) {
              const description = main.querySelector('.product__description');
              if (description) this.setDescription(description.innerHTML, url);
            }
            const blocks = [];
            main.querySelectorAll('.product__accordion').forEach((block) => {
              const title = block.querySelector('.accordion__title')?.textContent.trim();
              const content = block.querySelector('.accordion__content');
              if (title && content) blocks.push({ title, content });
            });
            main.querySelectorAll('.product-popup-modal__content-info').forEach((content) => {
              const heading = content.querySelector('h1, h2, h3');
              const title = heading?.textContent.trim();
              if (!title) return;
              heading.remove();
              blocks.push({ title, content });
            });
            const seen = new Set();
            blocks.forEach(({ title, content }) => {
              const key = title + ':' + content.textContent.trim();
              if (seen.has(key)) return;
              seen.add(key);
              const fragment = this.sanitize(content, url);
              if (!fragment.textContent.trim() && !fragment.querySelector('img')) return;
              const details = this.ownerDocument.createElement('details');
              details.className = 'fs-live-quickview__detail';
              const summary = this.ownerDocument.createElement('summary');
              summary.textContent = title;
              const body = this.ownerDocument.createElement('div');
              body.className = 'fs-live-quickview__rich';
              body.append(fragment);
              details.append(summary, body);
              this.el('details').append(details);
            });
            this.detailsLoaded = true;
          })
        ]);
        if (!this.dialog.open || this.controller !== controller) return;
        const failed = results.some((result) => result.status === 'rejected');
        this.el('status').textContent = failed ? this.label('labelError') : '';
        this.el('retry').hidden = !failed;
        this.el('empty').hidden = failed || this.descriptionLoaded || Boolean(this.el('details').children.length);
      } catch (_) {
        if (signal.aborted || !this.dialog.open) return;
        this.el('status').textContent = this.label('labelError');
        this.el('retry').hidden = false;
      } finally {
        clearTimeout(timer);
        if (this.controller?.signal === signal) this.el('content').setAttribute('aria-busy', 'false');
      }
    }
    setPhotos(photos) {
      this.photos = photos.map((photo) => ({ ...photo, src: safeImage(photo.src, location.origin) })).filter((photo) => photo.src);
      this.photoImages = [];
      this.carousel.replaceChildren();
      this.photoIndex = 0;
      if (!this.photos.length) {
        const empty = this.ownerDocument.createElement('p');
        empty.dataset.fsProductNoImage = '';
        empty.textContent = this.noImageText;
        this.carousel.append(empty);
      }
      this.photos.forEach((photo, index) => {
        const slide = this.ownerDocument.createElement('div');
        slide.className = 'fs-live-quickview__slide';
        slide.dataset.fsProductSlide = String(index);
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-label', this.photoLabel(index));
        const img = this.ownerDocument.createElement('img');
        img.src = photo.src;
        img.alt = photo.alt || this.el('title').textContent;
        img.width = 700;
        img.height = 875;
        img.draggable = false;
        const fallback = this.ownerDocument.createElement('p');
        fallback.dataset.fsProductNoImage = '';
        fallback.textContent = this.noImageText;
        fallback.hidden = true;
        img.addEventListener('error', () => { img.hidden = true; fallback.hidden = false; }, { once: true });
        slide.append(img, fallback);
        this.carousel.append(slide);
        this.photoImages.push(img);
      });
      const thumbs = this.el('thumbs');
      thumbs.replaceChildren();
      this.photos.forEach((photo, index) => {
        const button = this.ownerDocument.createElement('button');
        button.type = 'button';
        button.dataset.fsProductPhoto = String(index);
        button.setAttribute('aria-label', this.photoLabel(index));
        const img = this.ownerDocument.createElement('img');
        img.src = photo.src;
        img.alt = '';
        img.width = 72;
        img.height = 90;
        img.loading = 'lazy';
        button.append(img);
        thumbs.append(button);
      });
      thumbs.hidden = this.photos.length < 2;
      this.el('photo-controls').hidden = this.photos.length < 2;
      this.showPhoto(0);
    }
    photoLabel(index) { return this.label('labelPhoto').replace('{current}', String(index + 1)).replace('{total}', String(this.photos.length)); }
    selectPhoto(index) {
      if (!this.photos.length) {
        this.image = null;
        this.el('counter').textContent = '';
        return;
      }
      this.photoIndex = Math.max(0, Math.min(this.photos.length - 1, index));
      this.photoImages.forEach((image, position) => {
        if (position === this.photoIndex) image.setAttribute('data-fs-product-image', '');
        else image.removeAttribute('data-fs-product-image');
      });
      this.image = this.photoImages[this.photoIndex];
      this.el('counter').textContent = this.photoLabel(this.photoIndex);
      this.el('thumbs').querySelectorAll('button').forEach((button, position) => button.setAttribute('aria-pressed', String(position === this.photoIndex)));
    }
    alignPhoto() {
      const width = this.carousel.clientWidth;
      if (!width || !this.photos.length) return;
      const left = width * this.photoIndex;
      if (typeof this.carousel.scrollTo === 'function') this.carousel.scrollTo({ left, behavior: 'auto' });
      else this.carousel.scrollLeft = left;
    }
    showPhoto(index) {
      const next = this.photos.length ? (index + this.photos.length) % this.photos.length : 0;
      this.selectPhoto(next);
      this.alignPhoto();
    }
    setDescription(html, base) {
      const source = new DOMParser().parseFromString(html, 'text/html');
      const fragment = this.sanitize(source.body, base);
      if (!fragment.textContent.trim() && !fragment.querySelector('img')) return;
      this.el('description-content').replaceChildren(fragment);
      this.el('description').hidden = false;
      this.descriptionLoaded = true;
    }
    sanitize(source, base) {
      const output = this.ownerDocument.createDocumentFragment();
      const copy = (node, parent) => {
        if (node.nodeType === 3) { parent.append(this.ownerDocument.createTextNode(node.textContent)); return; }
        if (node.nodeType !== 1 || blockedTags.has(node.tagName)) return;
        if (!allowedTags.has(node.tagName)) { Array.from(node.childNodes).forEach((child) => copy(child, parent)); return; }
        const tag = /^H[1-6]$/.test(node.tagName) ? 'h4' : node.tagName.toLowerCase();
        const element = this.ownerDocument.createElement(tag);
        if (tag === 'img') {
          const src = safeImage(node.getAttribute('src') || node.getAttribute('data-src'), base);
          if (!src) return;
          element.src = src;
          element.alt = node.getAttribute('alt') || '';
          element.loading = 'lazy';
          element.decoding = 'async';
          ['width', 'height'].forEach((attribute) => {
            const value = node.getAttribute(attribute);
            if (/^\d{1,5}$/.test(value || '')) element.setAttribute(attribute, value);
          });
        }
        if (tag === 'td' || tag === 'th') {
          ['colspan', 'rowspan'].forEach((attribute) => {
            const value = node.getAttribute(attribute);
            if (/^[1-9]\d?$/.test(value || '')) element.setAttribute(attribute, value);
          });
          if (['row', 'col', 'rowgroup', 'colgroup'].includes(node.getAttribute('scope'))) element.setAttribute('scope', node.getAttribute('scope'));
        }
        Array.from(node.childNodes).forEach((child) => copy(child, element));
        parent.append(element);
      };
      Array.from(source.childNodes).forEach((node) => copy(node, output));
      return output;
    }
  }
  customElements.define('fs-live-quickview', FsLiveQuickview);
})();
